module.exports = __webpack_public_path__ + "img/1.5f05668b.png";